<template>
  <div class="p-3 filter-container">
    <div class="col-md-12">
      <div class="row">
        <div class="col-12 col-md-4 col-lg-3 py-1">
          <ValidationProvider
            ref="academicYearValidator"
            v-slot="{ errors }"
            name="año académico"
            rules="required"
          >
            <custom-drop-down
              v-model="selectedAcademicYear"
              fieldname="description"
              fieldkey="id"
              :options="academicYears"
              placeholder="Seleccione el Año Académico"
              :error="errors[0]"
              :custom-error-msg.sync="GetMessage('18018').name"
              @input="OnChange('academicYear', $event)"
            />
          </ValidationProvider>
        </div>

        <div class="col-12 col-md-4 col-lg-6 col-xl-7 py-1">
          <custom-drop-down
            v-model="selectedSubmittedDocumentDeterminationStatus"
            fieldname="name"
            fieldkey="id"
            :options="submittedDocumentDeterminationStatuses"
            placeholder="Seleccione el Estatus del Documento"
          />
        </div>

        <div class="col-12 col-md-4 col-lg-3 col-xl-2 py-1 pl-0">
          <div class="row fr mr-sm-n4">
            <div class="col-4 col-md-4">
              <action-button
                :class="{ transparent: !advance }"
                class="pl-3"
                i="fal fa-sliders-v"
                variant="orange"
                @click="() => (advance = !advance)"
              />
            </div>
            <div class="col-8 col-md-6">
              <action-button
                :disabled="!selectedAcademicYear"
                text="Buscar"
                variant="success"
                class="px-4"
                @click="Search()"
              />
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="advance" class="col-md-12">
      <div class="row py-3">
        <div class="col-md-12">
          <span class="separator">FILTROS</span>
        </div>
      </div>

      <div class="row">
        <div class="col-12 col-md-4 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="selectedRegion"
              fieldname="name"
              fieldkey="id"
              :options="regions"
              placeholder="Región"
              :disabled="!selectedAcademicYear || isDirector"
              @input="OnChange('region', $event)"
            />
          </div>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="selectedDistrict"
              fieldname="name"
              fieldkey="id"
              :options="districts"
              placeholder="Distrito"
              :disabled="!selectedRegion || isDirector"
              @input="OnChange('district', $event)"
            />
          </div>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <div class="custom-ddf">
            <custom-drop-down
              v-model="selectedSchool"
              fieldname="name"
              fieldkey="id"
              :options="schools"
              placeholder="Escuela"
              :clearable="!isDirector"
              :disabled="
                !selectedDistrict || (isDirector && schools.length <= 1)
              "
            />
          </div>
        </div>
        <div class="col-12 col-md-4 pb-3">
          <custom-drop-down
            v-model="selectedCourtStipulation"
            fieldname="name"
            fieldkey="id"
            :options="courtStipulations"
            placeholder="Estipulación"
          />
        </div>
        <div class="col-12 col-md-4 pb-3">
          <custom-drop-down
            v-model="selectedSentenceArea"
            fieldname="name"
            fieldkey="id"
            :options="sentenceAreas"
            placeholder="Área de Sentencia"
          />
        </div>
        <div class="col-12 col-md-4 pb-3">
          <custom-drop-down
            v-model="selectedSubmittedDocumentType"
            fieldname="name"
            fieldkey="id"
            :options="submittedDocumentTypes"
            placeholder="Tipo de Documento"
            :disabled="!selectedAcademicYear"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CustomDropDown from '@/components/common/CustomDropDown';
import { ActionButton } from '@/components/common';
import LocationService from '@/services/api/location.api';
import schoolTypes from '@/utils/constants/student/schoolTypes';
import storeMixin from '@/mixin/storeGenerator';
export default {
  name: 'RLVEvidenceAdvancedSearch',
  components: {
    CustomDropDown,
    ActionButton,
  },
  props: {},
  mixins: [storeMixin],
  data() {
    return {
      advance: false,
      // Academic Years
      selectedAcademicYear: null,
      academicYears: [],
      // Regions
      selectedRegion: null,
      regions: [],
      // Districts
      selectedDistrict: null,
      districts: [],
      // Schools
      selectedSchool: null,
      schools: [],
      // Court Stipulations
      selectedCourtStipulation: null,
      courtStipulations: [],
      // Sentence Area
      selectedSentenceArea: null,
      sentenceAreas: [],
      // Statuses
      selectedSubmittedDocumentDeterminationStatus: null,
      submittedDocumentDeterminationStatuses: [],
      // Types
      selectedSubmittedDocumentType: null,
      submittedDocumentTypes: [],
    };
  },
  watch: {
    selectedAcademicYear: function(previousValue, newValue) {
      this.OnChange('academicYear', newValue);
    },
  },
  methods: {
    async LoadAcademicYears() {
      await this.$ApiGet(
        `api/academicyears/getallrlvevidenceacademicyears`
      ).then((res) => {
        this.academicYears = res.data;
        this.LoadCurrentAcademicYear();
      });
    },
    async LoadCurrentAcademicYear() {
      await this.$ApiGet('/api/academicyears/current').then((res) => {
        this.selectedAcademicYear = res.data;
        this.LoadRegions();
        this.LoadSubmittedDocumentTypes();
      });
    },
    async LoadCourtStipulations() {
      await this.$ApiGet(`api/code/getcourtstipulations`).then((res) => {
        res.data.unshift({ id: -1, name: 'Todos' });
        this.courtStipulations = res.data;
      });
    },
    async LoadSubmittedDocumentDeterminationStatuses() {
      await this.$ApiGet(
        `api/code/getsubmitteddocumentdeterminationstatuses`
      ).then((res) => {
        res.data.unshift({ id: -1, name: 'Todos' });
        this.submittedDocumentDeterminationStatuses = res.data;
      });
    },
    async LoadSentenceAreas() {
      await this.$ApiGet(`api/code/getsentenceareas`).then((res) => {
        res.data.unshift({ id: -1, name: 'Todos' });
        this.sentenceAreas = res.data;
      });
    },
    async LoadSubmittedDocumentTypes() {
      await this.$ApiGet(`api/code/getsubmitteddocumenttype/academicYearId`, {
        academicYearId: this.selectedAcademicYear.id,
      }).then((res) => {
        res.data.unshift({ id: -1, name: 'Todos' });
        this.submittedDocumentTypes = res.data;
      });
    },
    async LoadValidationMessages() {
      const messageCodes = ['18018'];
      const promise = this.$ApiGet(
        '/api/validationsmessages?messageCodes=' +
          messageCodes.join('&messageCodes=')
      );
      promise.then((res) => {
        this.validationMessages = res.data;
      });
    },
    LoadRegions() {
      if (this.selectedAcademicYear == null) return;
      LocationService.getRegions({
        AcademicYearId: this.selectedAcademicYear.id,
      }).then((response) => {
        this.regions = response.data;
        if (this.regions.length == 1) {
          this.selectedRegion = this.regions[0];
          this.LoadDistricts(this.selectedRegion.id); //Exception :'(
        }
      });
    },
    LoadDistricts(regionId) {
      LocationService.getDistricts({
        AcademicYearId: this.selectedAcademicYear.id,
        RegionId: regionId,
      }).then((response) => {
        this.districts = response.data;
        if (
          this.districts.length == 1 ||
          (this.isDirector && this.districts.length > 0)
        ) {
          this.selectedDistrict = this.districts[0];
          this.LoadSchools(this.selectedDistrict.id); //Exception :'(
        }
      });
    },
    LoadSchools(districtId) {
      LocationService.getSchools({
        AcademicYearId: this.selectedAcademicYear.id,
        DistrictId: districtId == undefined ? null : districtId,
        RegionId: districtId == undefined ? null : this.selectedRegion.id,
        SchoolTypes: schoolTypes.PublicSchool,
      }).then((response) => {
        this.schools = response.data;
        if (
          this.schools.length == 1 ||
          (this.isDirector && this.schools.length > 0)
        ) {
          this.selectedSchool = this.schools[0];
        }
      });
    },
    OnChange(selectedType, selectedValue) {
      if (this.isDirector) {
        this.LoadRegions();
        this.LoadDistricts();
        this.LoadSchools();
        this.LoadSubmittedDocumentTypes();
      } else {
        if (selectedType === 'academicYear') {
          this.selectedRegion = null;
          this.selectedDistrict = null;
          this.selectedSchool = null;
          this.selectedSubmittedDocumentType = null;

          this.regions = [];
          this.districts = [];
          this.schools = [];
          this.submittedDocumentTypes = [];

          this.LoadRegions();
          this.LoadSubmittedDocumentTypes();
        }

        if (selectedType === 'region') {
          this.selectedDistrict = null;
          this.selectedSchool = null;

          this.districts = [];
          this.schools = [];

          this.LoadDistricts(selectedValue.id);
        } else if (selectedType === 'district') {
          this.selectedSchool = null;

          this.schools = [];
          this.LoadSchools(selectedValue.id);
        }
      }
    },
    Search() {
      const vm = {
        academicYearId: this.selectedAcademicYear.id,
        regionId:
          this.selectedRegion && this.selectedRegion.id > 0
            ? this.selectedRegion.id
            : null,
        districtId:
          this.selectedDistrict && this.selectedDistrict.id > 0
            ? this.selectedDistrict.id
            : null,
        locationSchoolId:
          this.selectedSchool && this.selectedSchool.id > 0
            ? this.selectedSchool.id
            : null,
        sentenceAreaId:
          this.selectedSentenceArea && this.selectedSentenceArea.id > 0
            ? this.selectedSentenceArea.id
            : null,
        submittedDocumentTypeId:
          this.selectedSubmittedDocumentType &&
          this.selectedSubmittedDocumentType.id > 0
            ? this.selectedSubmittedDocumentType.id
            : null,
        determination:
          this.selectedSubmittedDocumentDeterminationStatus &&
          this.selectedSubmittedDocumentDeterminationStatus.id > 0
            ? this.selectedSubmittedDocumentDeterminationStatus.id
            : null,
        stipulation:
          this.selectedCourtStipulation && this.selectedCourtStipulation.id > 0
            ? this.selectedCourtStipulation.id
            : null,
      };
      this.$store.dispatch('setSelectedEvidenceReportParams', vm);
      this.$emit('searchHandler', vm);
    },
    GetMessage(code) {
      const message = this.validationMessages
        ? this.validationMessages.find((element) => element.id == code)
        : '';

      return message;
    },
  },
  async mounted() {
    this.LoadValidationMessages();
    this.LoadAcademicYears();
    this.LoadCourtStipulations();
    this.LoadSubmittedDocumentDeterminationStatuses();
    this.LoadSentenceAreas();
    this.isDirector = this.userProfile.role.toLowerCase() == 'director';
  },
  async created() {
    await this.recoveryData();
  },
  destroyed() {
    this.persistData();
  },
};
</script>

<style scoped>
/* BADGES */
.badge.no-interview {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.badge.completed {
  height: 32px;
  background: #a3e5b3 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.btn-setting {
  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0px !important;
  color: #ffffff;
  opacity: 1;
}

/* FILTER CONTAINER */
.filter-container {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

/* SEPARATOR */
.separator {
  display: flex;
  align-items: center;
  text-align: center;
  color: #aab7b1;
  font: 900 14px/17px Lato;
}
.separator::before,
.separator::after {
  content: '';
  flex: 1;
  border-bottom: 1px solid #aab7b1;
}
.separator::before {
  margin-right: 0.5em;
}
.separator::after {
  margin-left: 0.5em;
}

/* CUSTOM DROPDOWN */
.custom-ddf :placeholder-shown,
.custom-ddf .vs__search::placeholder {
  color: #495057;
  opacity: 0.8;
  line-height: 1.6;
}

.btn-setting-off {
  background-color: #f4f6f3;
  border-radius: 4px;
  border: 0px !important;
  color: #3f5b60;
}

.search-bar {
  background: #f4f6f3 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
}

.title-divider {
  border: 1px solid #b5c3bc;

  opacity: 1;
}
.title-content {
  background: #3f5b60 0% 0% no-repeat padding-box;
  border-radius: 21px;
  opacity: 1;
  text-align: center;
  font: Bold 17px/23px Lato;
  letter-spacing: 0;
  color: #ffffff;
}
.filter-content {
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #aab7b1;
  opacity: 1;
}

.no-info {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;
  border-left-style: solid;
  border-color: #e8e8e8;
  border-width: 0;
}
.no-info-text {
  text-align: left;
  font: Bold 16px/22px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}
.no-info-icon {
  color: #727272;
  font-size: 32px;
}

.interview-status {
  height: 32px;
  background: #f8eb7f 0% 0% no-repeat padding-box;
  border-radius: 18px;
  opacity: 1;
  text-align: center;
  font: Bold 16px/21px Lato;
  letter-spacing: 0;
  color: #11291b;
}
.egress-interview {
  background: #f7f7f7 0% 0% no-repeat padding-box;
  border-radius: 5px;
  opacity: 1;

  border-left-style: solid;
  border-color: #f8eb7f;
  border-width: 4px;
}

.btn-dropdown-actions {
  text-align: center;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1rem;
  color: rgb(12, 19, 16);
  border-radius: 4px;
  margin-right: 0px;
  border: 1px solid #2db782;
}
.dropdown-menu {
  margin-top: 1rem;
}

.dropdown-item {
  font: Regular 16px/19px Lato;
}

.dropdown-item i {
  margin-right: 1rem;
}

.drop-item {
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 0.9375rem;
  color: #11291b;
  text-align: inherit;
  white-space: nowrap;
  display: block;
  padding: 0.29rem 1.5rem;
  clear: both;
}

.dropdown-action-divider {
  border-top-width: 1px;
  border-top-style: solid;
  border-color: #e2e2e2;
  margin-left: 5%;
  margin-right: 5%;
}

.settings-button {
  align-content: center;

  background: #ff7058 0% 0% no-repeat padding-box;
  border-radius: 4px;
  opacity: 1;
}

.icon {
  font-size: 35px;
  height: 60px;
  width: 60px;
  border: solid 3px;
  border-radius: 127px;
  padding-top: 8px;
  padding-right: 4px;
  color: #e2e2e2;
}

.egress-interview.no-interview {
  border-color: #f8eb7f;
}

.egress-interview.completed {
  border-color: #a3e5b3;
}

.egress-interview.in-process {
  border-color: #d5b89a;
}
</style>
